import GamesIcon from '@material-ui/icons/Games';
import WordFinderConfigEdit from './components/WordFinderConfigEdit';
import { roles, APP_TYPES } from '../../config/constants';

const options = {
  appTypes: [APP_TYPES.HUNGARY],
  allowedRoles: [roles.ADMIN, roles.JTI_TEAM],
  label: 'Ploom word search',
};

export default {
  list: WordFinderConfigEdit,
  icon: GamesIcon,
  name: 'admin/word-finder-config',
  options,
};
